<div [class]="'logo-' + color" aria-label="MYGEO" role="img"><strong>MY</strong><span>GEO</span></div>
